import React from 'react';

import { Typography, Grid, Link } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import uhcLogo from '../assets/uhcLogo.svg';
import grandma from '../assets/heroLady.jpg';
import grandmaM from '../assets/heroLadyM.jpg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '5.6rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2rem'
    }
  },
  logo: {
    position: 'absolute',
    right: '2rem',
    top: '6rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  textBox: {
    width: '41%',
    textAlign: 'center',
    marginTop: '3.2rem',
    [theme.breakpoints.down('sm')]: {
      width: '86%',
      marginTop: '1.5rem'
    }
  },
  grandma: {
    width: '100%',
    marginTop: '4.75rem',

    [theme.breakpoints.down('sm')]: {
      marginTop: '2.5rem'
    }
  },
  caption: {
    marginTop: '5px'
  },
  mobileH1: {
    width: '80%',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '85%',
      fontSize: '32px',
      lineHeight: '36px',
      textAlign: 'center'
    }
  }
}));

const Hero = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <a
        href="https://www.aarpmedicareplans.com/?WT.mc_id=8003294"
        target="_blank"
        rel="sponsored noopener"
      >
        <img src={uhcLogo} alt="UHC logo" className={classes.logo} />
      </a>
      <Grid container direction="column" alignItems="center" className={classes.wrapper}>
        {/* <Grid item alignItems="center"> */}
        <Typography variant="h1" className={classes.mobileH1}>
          Friendship Forged Through Compassion and Trust
        </Typography>
        {/* </Grid> */}
        <Grid item>
          <hr style={{ marginTop: '1rem', width: '140px' }} />
        </Grid>
        <Grid item className={classes.textBox}>
          <Typography variant="h2">
            Pat turned to Nikki to help her navigate her Medicare Advantage health plan benefits.
            She didn’t realize one of the benefits was friendship.
          </Typography>
        </Grid>
        <Grid item>
          <img
            src={matchesSM ? grandmaM : grandma}
            alt="grandma reading on chair"
            className={classes.grandma}
          />
        </Grid>
        <Grid item className={classes.caption}>
          <Typography variant="caption">Pat Gill at home in Berea, Ohio</Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default Hero;
